<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
                        danh sách lịch làm việc</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                        <label>Tên công dân/Số diện thoại:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Tên công dân/Số diện thoại..." v-model="search.cTieuDe" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                        <label>Ngày hẹn:</label>
                        <el-row :gutter="10">
                            <el-date-picker
                                v-model="search.date"
                                type="daterange"
                                range-separator="đến"
                                start-placeholder="Từ ngày"
                                end-placeholder="Đến ngày"
                                format="DD/MM/YYYY"
                            />
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Trạng thái:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                                    <el-option label="Tất cả" value="" selected></el-option>
                                    <el-option label="Chờ xác nhận" value="1" selected></el-option>
                                    <el-option label="Đồng ý" value="2" selected></el-option>
                                    <el-option label="Từ chối" value="3" selected></el-option>
                                    <el-option label="Đã xóa" value="0" selected></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                                        class="fa fa-search"></i></el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <div class="body-function">
                    <div class="col-md-12">
                        <h4>Danh sách lịch làm việc</h4>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
                        height="100%" fit stripe highlight-current-row>
                        <el-table-column prop="nMa" label="Mã" width="100" align="center"></el-table-column>
                        <el-table-column prop="cHoTen" label="Họ tên công dân" min-width="150" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="cSoDienThoai" label="Số điện thoại" min-width="150" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="cDiaChi" label="Địa chỉ" min-width="150" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="cTenThuTuc" label="Thủ tục" min-width="150" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="dThoiGianLamViec" label="Ngày hẹn" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dThoiGianLamViec) }}
                            </template>
                        </el-table-column>

                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayTao) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
                                <el-tag type="warning" v-if="scope.row.nTinhTrang == 1" size="small">Chờ xác nhận</el-tag>
                                <el-tag type="success" v-if="scope.row.nTinhTrang == 2" size="small">Đồng ý</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 3" size="small">Từ chối</el-tag>
                            </template>
                        </el-table-column>
                        <!-- Button hành động -->
                        <el-table-column width="150" label="Hành động" align="center">
                            <template #default="scope">

                                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('sys:workschedule:edit')"
                                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal"
                                    data-bs-target="#modal_hotline">
                                    <span class="btn-inner--icon"><i class="fas fa-info"></i></span>
                                </el-button>

                                <el-button plain type="danger" :disabled="scope.row.nTinhTrang != 1 || !handleCheckPerms('sys:workschedule:delete')"
                                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_hotline" ref="hotlineModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-750px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_hotline_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">Thông tin lịch làm việc</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                        <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="140px" size="normal" class="d-block work-schedule">
                            <!-- Citizen Group -->
                            <div class="modal-section">
                                <div class="section-header">Thông tin công dân</div>
                                <el-row :gutter="12" class="section-body">
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Họ tên" prop="cHoTen">
                                            <el-input v-model="formData.cHoTen" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Số điện thoại" prop="cSoDienThoai">
                                            <el-input v-model="formData.cSoDienThoai" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :xs="24" :sm="24" :md="24">
                                        <el-form-item label="Địa chỉ" prop="cDiaChi">
                                            <el-input v-model="formData.cDiaChi" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :xs="24" :sm="24" :md="24">
                                        <el-form-item label="Tổ dân phố" prop="cToDanPho">
                                            <el-input v-model="formData.cTenToDanPho" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>

                            <!-- Officer Group -->
                            <div class="modal-section">
                                <div class="section-header">Thông tin cán bộ</div>
                                <el-row :gutter="12" class="section-body">
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Cán bộ phụ trách" prop="cCanBo">
                                            <el-input v-model="formData.cTenPhuTrach" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="SĐT cán bộ" prop="cCanBoSDT">
                                            <el-input v-model="formData.nSdtPhuTrach" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>

                            <!-- Schedule Group -->
                            <div class="modal-section">
                                <div class="section-header">Lịch hẹn</div>
                                <el-row :gutter="12" class="section-body">
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Tên thủ tục" prop="cTenThuTuc">
                                            <el-input v-model="formData.cTenThuTuc" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Ngày hẹn" prop="dThoiGianLamViec">
                                            <el-input :value="momentDate(formData.dThoiGianLamViec)" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Ngày tạo" prop="dNgayTao">
                                            <el-input :value="momentDate(formData.dNgayTao)" readonly class="readonly-input"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12">
                                        <el-form-item label="Trạng thái" prop="nTinhTrang">
                                            <el-tag :type="statusTagType(formData.nTinhTrang)" effect="dark">{{ statusLabel(formData.nTinhTrang) }}</el-tag>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>

                            <!-- Notes Group -->
                            <div class="modal-section">
                                <div class="section-header">Ghi chú</div>
                                <el-row :gutter="12" class="section-body">
                                    <el-col :xs="24">
                                        <el-form-item label="Ghi chú của công dân" prop="cGhiChu">
                                            <el-input type="textarea" rows="2" v-model="formData.cCongDanGhiChu" readonly class="readonly-textarea"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :xs="24">
                                        <el-form-item label="Ghi chú của cán bộ" prop="cGhiChuCanBo">
                                            <el-input type="textarea" rows="2" v-model="formData.cCskvGhiChu" readonly class="readonly-textarea"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                            <!-- <el-button plain type="primary" @click="handleSave" :disabled="!handleCheckPerms('sys:workschedule:edit')">Lưu</el-button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { WorkSchedule } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";

export default {
    name: 'WorkSchedule',
    data() {
        return {
            perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [], 
            search: {
                cTieuDe: "",
                date: [moment().startOf("month").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
                nTinhTrang: "",
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 20,
                pageNum: 1
            },
            formData: {
                cTenThuTuc: "",
                nTinhTrang: 1,
                cHoTen: "",
                cSoDienThoai: "",
                cDiaChi: "",
                cTenToDanPho: "",
                cTenPhuTrach: "",
                nSdtPhuTrach: "",
                dThoiGianLamViec: "",
                cCongDanGhiChu: "",
                cCskvGhiChu: "",
                dNgayTao: "",
            },
            rules: {
                // cTenThuTuc: [{ required: true, message: "Xin vui lòng điền tên lịch làm việc", trigger: "blur" }],
                // cHoTen: [{ required: true, message: "Xin vui lòng điền họ tên công dân", trigger: "blur" }],
                // cSoDienThoai: [{ required: true, message: "Xin vui lòng điền số điện thoại", trigger: "blur" }],
            },
            tableData: {
                content: [{}]
            },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore(),
        }
    },
    methods: {
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenAdd() {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = false
            this.formData = {
                cTenThuTuc: "",
                nTinhTrang: 1,
                cHoTen: "",
                cSoDienThoai: "",
                cDiaChi: "",
                cTenToDanPho: "",
                cTenPhuTrach: "",
                nSdtPhuTrach: "",
                dThoiGianLamViec: "",
                cCongDanGhiChu: "",
                cCskvGhiChu: "",
                dNgayTao: "",
            }
        },
        handleOpenEdit(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({
                cTenThuTuc: "",
                nTinhTrang: 1,
                cHoTen: "",
                cSoDienThoai: "",
                cDiaChi: "",
                cTenToDanPho: "",
                cTenPhuTrach: "",
                nSdtPhuTrach: "",
                dThoiGianLamViec: "",
                cCongDanGhiChu: "",
                cCskvGhiChu: "",
                dNgayTao: "",
            }, val)
        },
        handleClose() {
            this.$refs.formData.resetFields()
            this.modalVisible = false
            hideModal(this.$refs.hotlineModalRef)
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa lịch làm việc này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    this.store.dispatch(WorkSchedule.deleteWorkSchedule, val).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: "Xóa lịch làm việc thành công", type: "success" });
                            this.handleFindPage()
                        } else {
                            ElMessage({ message: res.msg, type: "error" });
                        }
                    }).catch((error) => {
                        ElMessage({ message: "Xóa lịch làm việc thất bại", type: "error" });
                    })
                }).catch(() => {

                })
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTieuDe: {value:this.search.cTieuDe},
                nTinhTrang: {value:this.search.nTinhTrang},
                startDate:  {value: this.search.date.length == 2 ? moment(this.search.date[0]).format("YYYY-MM-DD") : ""},
                endDate:  {value: this.search.date.length == 2 ? moment(this.search.date[1]).format("YYYY-MM-DD") : ""},
            }
            this.store.dispatch(WorkSchedule.findPageWorkSchedule, this.pageRequest).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm lịch làm việc thất bại", type: "error" });
            })
        },
        handleSave() {
            this.$refs.formData.validate((valid) => {
                if (valid)
                    this.$confirm("Bạn có muốn lưu lịch làm việc này không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    })
                        .then(() => {
                            const data = Object.assign({}, this.formData);
                            this.store.dispatch(WorkSchedule.saveWorkSchedule, data).then(res => {
                                if (res.code == 200) {
                                    ElMessage({ message: this.operation ? "Cập nhật lịch làm việc thành công" : "Thêm lịch làm việc thành công", type: "success" });
                                    this.handleClose()
                                    this.handleFindPage()
                                }
                                else {
                                    ElMessage({ message: res.msg, type: "error" });
                                }
                            }).catch((error) => {
                                ElMessage({ message: this.operation ? "Cập nhật lịch làm việc thất bại" : "Thêm lịch làm việc thât bại", type: "error" });
                            })

                        }).catch(() => {

                        })
            })
        },


        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY HH:mm") : ""
        },
        statusLabel(n) {
            switch (Number(n)) {
                case 0:
                    return 'Đã xóa'
                case 1:
                    return 'Chờ xác nhận'
                case 2:
                    return 'Đồng ý'
                case 3:
                    return 'Từ chối'
                default:
                    return 'Không xác định'
            }
        },
        statusTagType(n) {
            switch (Number(n)) {
                case 0:
                    return 'danger'
                case 1:
                    return 'warning'
                case 2:
                    return 'success'
                case 3:
                    return 'danger'
                default:
                    return 'info'
            }
        },
        handleCheckPerms(val){
            return this.perms.includes(val)
        }
    },
    mounted() {
        this.handleFindPage()
    }
};
</script>
<style lang="scss" scoped>
.modal-section {
    margin-bottom: 9px;
    padding: 8px 12px;
    border-radius: 6px;
    background: #fbfbfb;
    border: 1px solid #eef2f6;
}
.modal-section .section-header {
    font-weight: 600;
    color: #34495e;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.modal-section .section-header::before {
    content: '';
    width: 4px;
    height: 20px;
    background: linear-gradient(180deg,#409eff,#74b3ff);
    border-radius: 2px;
}
.modal-section .section-body {
    padding-left: 6px;
}
.readonly-input >>> input,
.readonly-textarea >>> textarea {
    background-color: #fff !important;
    color: #222 !important;
}
.readonly-input .el-input__inner,
.readonly-textarea .el-textarea__inner {
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding-left: 0 !important;
}
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
/* small screens adjustments */
@media (max-width: 576px) {
    .modal-section {
        padding: 10px 8px;
    }
    .modal-section .section-header {
        font-size: 14px;
    }
}
</style>

<style>
.work-schedule .el-form-item {
    margin-bottom: 9px;
}
</style>